// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting_section_title_container {
    width: 93px;
    height: 32px;
    gap: 10px;
    opacity: 1;
    padding-right: 20px;
    padding-left: 20px;
}

.setting_section_text_container {
    height: 64px;
    gap: 10px;
    opacity: 1;
    padding: 8px;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    position: relative;
}

.setting_section_text {
    height: 16px;
    font-family: Roboto;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    background-color: #FFFFFF;
}

.setting_section_main_container {
    border-radius: 3px;
    border-width: 1px;
    fill: 244px;
    opacity: 1;
    padding-top: 32px;
    padding-right: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    width: 100%;
    box-sizing: border-box;
    gap: 20px;
    display: flex;
    flex-direction: column;
}

.setting_section_input_label {
    color: #203D48;
    opacity: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 4px;
    height: 14px;
    text-emphasis: #203D48;
    font-family: Roboto;
    font-weight: 400;
    font-style: Regular;
    font-size: 11.67px;
    line-height: 14px;
    letter-spacing: 0%;
    width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/QARuleForm/ruleCommonSection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".setting_section_title_container {\n    width: 93px;\n    height: 32px;\n    gap: 10px;\n    opacity: 1;\n    padding-right: 20px;\n    padding-left: 20px;\n}\n\n.setting_section_text_container {\n    height: 64px;\n    gap: 10px;\n    opacity: 1;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    background-color: #FFFFFF;\n    position: relative;\n}\n\n.setting_section_text {\n    height: 16px;\n    font-family: Roboto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    background-color: #FFFFFF;\n}\n\n.setting_section_main_container {\n    border-radius: 3px;\n    border-width: 1px;\n    fill: 244px;\n    opacity: 1;\n    padding-top: 32px;\n    padding-right: 20px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    width: 100%;\n    box-sizing: border-box;\n    gap: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.setting_section_input_label {\n    color: #203D48;\n    opacity: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0px;\n    gap: 4px;\n    height: 14px;\n    text-emphasis: #203D48;\n    font-family: Roboto;\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 11.67px;\n    line-height: 14px;\n    letter-spacing: 0%;\n    width: fit-content;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
